module.exports = __webpack_public_path__ + "static/media/geannuleerd_color.c9f3273f.svg";